<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<!-- 품번코드 -->
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:clearable="false"
						:placeholder="getMessage_('QWCC001656')"
						:propData="popupSearchParams.partNo"
						readonly
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
				<!-- <el-col :span="4">
					<search-input
						:label="getMessage_('QWCC000029')"
						paramKey="altrNo"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="popupSearchParams.altrNo"
					>
					</search-input>
				</el-col> -->
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<find-popup ref="findPopupView" @SendData="sendData" :scrId="scrId"></find-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import FindPopup from '../Eo4mFindPopup/FindPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return { searchDateRange: [] };
	},
	components: { SearchInput, FindPopup },
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setPopupSearchParams_(param);
		},
		onPartPopup() {
			this.$refs.findPopupView.open();
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			//this.$notify.closeAll(); // 에러 경고창 사라지는 명령어 (공통)
			let response;
			try {
				if (this.isSaved) {
					if (!this.popupSearchParams.partNo || !this.popupSearchParams.altrNo) {
						throw new Error(this.getMessage_('QWCC001747')); //검색 조건을 모두 입력바랍니다.
					}
					//수정된 내용이 있을 경우
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: this.getMessage_('QWCC001511'),
						buttons: [
							{
								title: 'Ok',
								clickFn: async () => {
									this.setPopupInit_();
									response = await this.getSearchOne_();
									this.getResponse(response);
								}
							}
						]
					});
				} else {
					const { partNo, altrNo } = this.detailForm;
					this.setPopupInit_();
					response = await this.getOne_({ partNo, altrNo });
					this.getResponse(response);
				}
				await this.setAltrSgrpList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.setState_({ key: 'isSaved', value: false });
				this.$sf_toggleLoading(false);
			}
		},
		sendData(param) {
			const { partNo, altrNo } = this.popupSearchParams;
			this.setPopupSearchParams_({ key: 'partNo', value: param.partNo });
			this.setPopupSearchParams_({ key: 'altrNo', value: param.altrNo });
			//수정된 내용이 있을 경우
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('QWCC001511'),
				buttons: [
					{
						title: 'Ok',
						clickFn: async () => {
							this.setPopupInit_();
							const response = await this.getSearchOne_();
							this.getResponse(response);
						}
					}
				],
				closeFn: () => {
					this.setPopupSearchParams_({ key: 'partNo', value: partNo });
					this.setPopupSearchParams_({ key: 'altrNo', value: altrNo });
				}
			});
		},
		getResponse(response) {
			if (response) {
				const { code, messageCd } = response;
				this.$sf_toast({
					type: code === 0 ? 'ok' : 'error',
					message: this.getMessage_(messageCd)
				});
				code == 0 && this.$emit('loadAll');
				code == 2 && this.$emit('initComp');
				this.setState_({ key: 'isSaved', value: false });
			} else {
				this.$sf_toast({
					type: 'error',
					message: this.getMessage_('QWCC001151')
				});
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
